import { KeyValue } from '@angular/common';

export class IndicatorResolverModel {
    private path: string;
    private linkId: string;


    constructor() {
    }

    get Path(): string { return this.path; }
    set Path(value: string) { this.path = value; }

    get LinkId(): string { return this.linkId; }
    set LinkId(value: string) { this.linkId = value; }
}
